module.exports = __webpack_public_path__ + "static/media/4db8c94e-7e49-4efd-9058-7641d0ac6627.3f65e071.JPG";